<p-dialog [(visible)]="display"
          [modal]="true"
          [showHeader]="false"
          [responsive]="true"
          [maximizable]="true"
          [draggable]="false"
          [resizable]="false"
          [style]="{width: '150px', minWidth: '150px'}">
    <div style="text-align: center">
        <app-loading></app-loading>
        <p>Aguarde...</p>
    </div>
</p-dialog>
